import { CreateTransactionForm } from "@ac-expo/api";
import { FormCountry, FormInput } from "@ac-expo/ui-components";
import { BuyerInformationsForm } from "@web-app/src/schema/embedTicketing.schema";
import { UseFormReturn } from "react-hook-form";

type Props = {
  transactionForm: UseFormReturn<CreateTransactionForm | BuyerInformationsForm>;
};

function BillingComponent({ transactionForm }: Props) {
  return (
    <>
      <FormInput
        className=""
        control={transactionForm.control}
        name="address.lastName"
        label="Nom"
        placeholder="Nom"
        type="text"
      />
      <FormInput
        className=""
        control={transactionForm.control}
        name="address.firstName"
        label="Prénom"
        placeholder="Prénom"
        type="text"
      />
      <FormInput
        control={transactionForm.control}
        name={"address.address1"}
        label={"Adresse postale"}
        className={"grow"}
        placeholder={"Adresse"}
      />
      <FormInput
        control={transactionForm.control}
        name={"address.address2"}
        label={"Complément d'adresse"}
        className={"grow"}
        placeholder={"Complément d'adresse"}
      />
      <div className={"flex w-full grow items-end gap-2"}>
        <FormInput
          control={transactionForm.control}
          name={"address.city"}
          className={"grow"}
          label={"Ville"}
          placeholder={"Ville"}
        />
        <FormInput
          control={transactionForm.control}
          name={"address.zipCode"}
          className={"grow"}
          label={"Code Postal"}
          placeholder={"Code Postal"}
        />
      </div>
      <FormCountry
        control={transactionForm.control}
        name="address.countryCode"
        label="Pays"
      />
    </>
  );
}

export default BillingComponent;
